import { render } from "./note.vue?vue&type=template&id=510264f5&ts=true"
import script from "./note.vue?vue&type=script&lang=ts"
export * from "./note.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__